import classnames from 'classnames'
import { Link } from '@platform/ui-kit'
import { ChevronRightIcon } from '@icons'

import styles from './index.module.scss'

type GeneralInformationCardProps = {
  className?: string
}

export const GeneralInformationCard = ({ className }: GeneralInformationCardProps) => {
  return (
    <div className={classnames(styles['card'], className)}>
      <h2 className={styles['title']}>Looking for general information?</h2>
      <p className={styles['description']}>We have FAQs to help you.</p>
      <Link
        href="/faq/talent"
        endIcon={ChevronRightIcon}
        className={styles['talent-link']}
        prefetch={false}
      >
        Talent FAQ
      </Link>
      <Link href="/faq/companies" endIcon={ChevronRightIcon} prefetch={false}>
        Companies FAQ
      </Link>
    </div>
  )
}
